import React, { useEffect } from "react";
import { Button } from "@qgiv/core-donor";
import { LoadingDots } from "@qgiv/core-react";
import { submitCancelRecurringPayment } from "@qgiv/donation-form";

/**
 * @param {object} props
 * @param {Function} props.handleError
 * @param {Function} props.handleSuccess
 * @param {boolean} props.loading
 * @param {string} props.modalDeclineButtonLabel
 * @param {Function} props.onClose
 * @param {number} props.recurringId
 * @param {Function} props.setLoading
 * @returns {React.JSX.Element}
 */
const RecurringSummaryCancelModalContent = ({
    handleError,
    handleSuccess,
    loading,
    modalDeclineButtonLabel,
    onClose,
    recurringId,
    setLoading,
}) => {
    useEffect(() => {
        let apiCallMounted = true;
        if (loading) {
            submitCancelRecurringPayment(recurringId)
                .then((response) => {
                    if (apiCallMounted) {
                        handleSuccess(response);
                    }
                })
                .catch(() => {
                    if (apiCallMounted) {
                        handleError();
                    }
                });
        }
        // Prevents updates to state on a unmounted component in the
        // case the api request is in progress and the modal is closed
        return () => {
            apiCallMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, recurringId]);

    const onClick = () => {
        setLoading(true);
    };

    return (
        <div className="-margin-top--30 -margin-bottom--60 -padding--30">
            <div className="grid--justify-content-center grid">
                <div className="col col--12 -padding-top--0 -text--center">
                    <h1>Cancel This Ongoing Gift?</h1>
                </div>
                <div className="col col--8 -text--center">
                    <p>
                        We understand it may not be the right time to continue
                        giving, but we hope you&apos;ll continue supporting our
                        vital work again soon.
                    </p>
                </div>
                <div className="col col--10 -padding-top--20">
                    <Button
                        type="submit"
                        disabled={loading}
                        btnStyle="primary"
                        onClick={onClick}
                    >
                        {loading ? (
                            <LoadingDots color="#ffffff" />
                        ) : (
                            "Yes, please cancel."
                        )}
                    </Button>
                </div>
                <div className="col col--10 -padding-top--10">
                    <Button
                        type="cancel"
                        disabled={loading}
                        btnStyle="secondary"
                        classes="-color--theme-primary"
                        onClick={onClose}
                    >
                        {modalDeclineButtonLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default RecurringSummaryCancelModalContent;
